import { createTypes } from '@elab/core/store/product/types';

export const storeName = 'minipdp';

export default createTypes(storeName);
